// extracted by mini-css-extract-plugin
export default {"shake":"useAnimation_shake__1LNyz"};